export default "__VITE_ASSET__CHNwJn7D__"